"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableMenuIsLocked_1 = require("../../../../../../../shared/components/table_menus/TableMenuIsLocked");
var TableActionComment_1 = require("../../../../../../../shared/components/table_actions/TableActionComment");
var PromoCodeTypeBonusesList = /** @class */ (function (_super) {
    __extends(PromoCodeTypeBonusesList, _super);
    function PromoCodeTypeBonusesList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Бонус',
                dataIndex: _this.props.data.dk_bonus_template_title,
                key: _this.props.data.dk_bonus_template_title,
                width: 250,
            }, {
                title: 'Тип',
                dataIndex: _this.props.data.dk_bonus_type_title,
                key: _this.props.data.dk_bonus_type_title,
                width: 250,
            }, {
                title: 'Добавлен',
                dataIndex: _this.props.data.dk_date_added2,
                key: _this.props.data.dk_date_added2,
                width: 250,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added2.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Заблокирован',
                dataIndex: _this.props.data.dk_is_locked,
                key: _this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать бонус", text: "Да" }, unlockedTexts: { menu: "Разблокировать бонус", text: "Нет" }, record: { key: record.key, title: record.bonus_template_title, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                },
                width: 150,
            }, {
                title: 'Комментарий',
                dataIndex: _this.props.data.dk_description,
                key: _this.props.data.dk_description,
                width: 250,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionComment_1.default, { hint: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439", onClick: function () { _this.onCommentClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 120
            }
        ];
        return _this;
    }
    PromoCodeTypeBonusesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.record.key);
        });
        this.SID_LBT = this.props.listPromoBonusesTemplatesAvail.Subscribe("*", function (id, data) {
            _this.setState({
                bonusTypesAvail: data.data
            }, function () {
                _this.props.dlgSelectBonusTemplate.SetViewData(_this.state.bonusTypesAvail);
            });
        });
        this.props.listPromoBonusesTemplatesAvail.LoadData(this.props.record.brand_id, this.props.record.promocode_template_type_code);
        this.props.state.setExtBreadCrumbPath(["\u0421\u043F\u0438\u0441\u043E\u043A \u0431\u043E\u043D\u0443\u0441\u043E\u0432 - [" + this.props.record.description + "]"]);
    };
    PromoCodeTypeBonusesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.listPromoBonusesTemplatesAvail.UnSubscribe(this.SID_LBT);
    };
    PromoCodeTypeBonusesList.prototype.doLockUnLockAction = function (Key, Title, Lock) {
        this.props.data.SetIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u043E\u043D\u0443\u0441\u0430 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u043E\u043D\u0443\u0441\u0430 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    PromoCodeTypeBonusesList.prototype.onCommentClick = function (record) {
        var _this = this;
        this.props.dlgDescriptionEditor.SetTitle("Изменить описание").SetDescription(record.description).SetOnYesClick(function (description) {
            _this.props.data.SetDescription(record.key, description, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0431\u043E\u043D\u0443\u0441\u0430 ",
                    React.createElement("b", null,
                        "[",
                        record.bonus_template_title,
                        "]"),
                    " \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u043E"));
            });
        }).Show();
    };
    PromoCodeTypeBonusesList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0411\u043E\u043D\u0443\u0441 ",
                React.createElement("b", null,
                    "[",
                    record.bonus_template_title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    PromoCodeTypeBonusesList.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.props.data.LoadData(this.props.record.key);
        }
        if (action === "create") {
            this.props.dlgSelectBonusTemplate.SetTitle("Выберите шаблон бонуса").SetOnReLoadData(function () {
                _this.props.listPromoBonusesTemplatesAvail.LoadData(_this.props.record.brand_id, _this.props.record.promocode_template_type_code);
            }).SetOnSelectClick(function (key, value) {
                _this.props.data.AddData({
                    bonus_template_id: key,
                    description: "",
                    is_locked: false,
                    promocode_template_id: _this.props.record.key
                }, function () {
                    if (!_this.props.dlgSelectBonusTemplate.DATA.notAutoCloseDialog) {
                        _this.props.dlgSelectBonusTemplate.Close();
                    }
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u0411\u043E\u043D\u0443\u0441 ",
                        React.createElement("b", null,
                            "[",
                            value,
                            "]"),
                        " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D"));
                });
            }).SetOnCloseClick(function () { _this.props.dlgSelectBonusTemplate.Close(); }).Show();
        }
        if (action == "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    PromoCodeTypeBonusesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { back: "Назад", create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added2.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                            "]")));
                }, scroll: { x: true } })));
    };
    return PromoCodeTypeBonusesList;
}(React.Component));
exports.default = PromoCodeTypeBonusesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_promocodes/ui/component/bonuses/PromoCodeTemplateBonusesList.tsx
// module id = 1969
// module chunks = 0